import React from "react";
import { Route, Routes } from "react-router-dom";
import FavoriteAddress from "./favoriteAddress";
import History from "./history";

import Home from "./home";
import MessagesCenter from "./messagesCenter";
import Navbar from './navbar';
import Profile from "./profile";

export default function Container() {
    return (
        <div className="p-0 vh-100" >

            <Routes  >
                <Route path='/' element={<Home />} />
                <Route path='/profile' element={<Profile />} />
                <Route path='/message' element={<MessagesCenter />} />
                <Route path='/favorite' element={<FavoriteAddress />} />
                <Route path='/history' element={<History showFilter={true}/>} />
            </Routes>

        </div >
    )
}